import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import {
    Avatar, Box, Button, Checkbox, Container, Grid, FormControlLabel, Link,
    TextField, Typography
} from '@mui/material';
import { LockOutlined } from '@mui/icons-material';
import Copyright from 'components/common/Copyright';
import useAuth from 'hooks/useAuth';


const Login = () => {
    const {t} = useTranslation();
    const {login} = useAuth();
    const navigate = useNavigate();
    const {state} = useLocation();
    const passRef = useRef<HTMLInputElement>(null);

    const submit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        const data = new FormData(event.currentTarget);

        login(
            data.get('email') as string,
            data.get('password') as string,
            !!data.get('remember')
        )
            .then(() => navigate(state.from || '/', {replace: true}))
            .catch(() => passRef.current!.value = '')
    };

    return (
        <Container component="main" maxWidth="xs">
            <Box
                sx={{
                    marginTop: 8,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                }}
            >
                <Avatar sx={{m: 1, bgcolor: 'secondary.main'}}>
                    <LockOutlined/>
                </Avatar>
                <Typography component="h1" variant="h5">
                    {t('sign_in')}
                </Typography>
                <Box component="form" onSubmit={submit} sx={{mt: 1}}>
                    <TextField
                        margin="normal"
                        required
                        type="email"
                        fullWidth
                        id="email"
                        label={t('email_address')}
                        name="email"
                        autoComplete="email"
                        autoFocus
                    />
                    <TextField
                        margin="normal"
                        required
                        fullWidth
                        name="password"
                        label={t('password')}
                        type="password"
                        id="password"
                        autoComplete="current-password"
                        inputRef={passRef}
                    />
                    <FormControlLabel
                        control={<Checkbox name="remember" value="remember" color="primary"/>}
                        label={t('remember_me')}
                    />
                    <Button
                        type="submit"
                        fullWidth
                        variant="contained"
                        sx={{mt: 3, mb: 2}}
                    >
                        {t('sign_in')}
                    </Button>
                    <Grid container justifyContent="space-between">
                        <Grid item>
                            <Link href="/forgot-password" variant="body2">
                                {t('forgot_password')}
                            </Link>
                        </Grid>
                        <Grid item>
                            <Link href="/register" variant="body2">
                                {t('register_as_shipper')}
                            </Link>
                        </Grid>
                    </Grid>
                </Box>
            </Box>
            <Copyright sx={{mt: 8, mb: 4}}/>
        </Container>
    );
};

export default Login;
